const EVENT_STATE = {
  future: 'future',
  finished: 'finished',
};

export default EVENT_STATE;
